import { SigningPinConstants } from './constant';

//  THIN-7681 signing-PIN status / setup / reset (see signing-pin-saga).
export const getSigningPinStatusRequest = () => ({
  type: SigningPinConstants.GET_SIGNING_PIN_STATUS_REQUEST,
});

export const setupSigningPinRequest = (pin: string) => ({
  type: SigningPinConstants.SETUP_SIGNING_PIN_REQUEST,
  payload: pin,
});

//  APIT-656: a reset now carries the account password that gates it. Kept out of any persisted
//  slice (signingPinReducer is not in the redux-persist whitelist) — it lives only for the
//  lifetime of the request.
export const resetSigningPinRequest = (newPin: string, accountPassword?: string) => ({
  type: SigningPinConstants.RESET_SIGNING_PIN_REQUEST,
  payload: { newPin, accountPassword },
});

//  Clears transient setup/reset success+error flags (e.g. when a dialog closes).
export const resetSigningPinActionState = () => ({
  type: SigningPinConstants.SIGNING_PIN_ACTION_RESET,
});
